import React from 'react';
import { TrackProgress } from '../components/progress/trackProgress';
import {Header} from '../components/global/header';
import {Footer} from '../components/global/footer';

const TrackProgressPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <TrackProgress />
      <Footer />
    </div>
  );
};

export default TrackProgressPage;
